import { render } from "./SiteHeader.vue?vue&type=template&id=298cc623"
import script from "./SiteHeader.vue?vue&type=script&lang=js"
export * from "./SiteHeader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Jenkins\\workspace\\BT5\\rptweb\\release-RPTWEB-3376\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__